
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: () => '',
    },
    description: {
      type: String,
      required: true,
      default: () => '',
    },
  },
  computed: {
    title() {
      return this.psgUnescapeHtml(this.name)
    },
  },
}
